








import Vue from 'vue';
import { Icon } from '@/components/ds';

export default Vue.extend({
  components: { Icon },
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String,
      default: null,
    },
  },
});
